import { React, useCallback } from "react";
import axios from "axios";
import { connect } from "react-redux";
import appConfig from "../../config/appConfig";
import { confirmDeleteConfig } from "../../config/confirmConfig";
import {
  toastDeleteErrorMessageConfig,
  toastDeleteSuccessMessageConfig,
  toastErrorMessageWithParameterConfig,
} from "../../config/toastConfig";
import { DeleteConfirmation } from "./ConfirmationAlert";
import { ToastBottomEnd } from "./Toast";
import CompleteAttachment from "./CompleteAttachment";
import { verifyPermission } from "../../helpers/permission";
import { useTranslation } from "react-i18next";

const AttachmentsButtonDetail = ({ claim, userPermissions, user }) => {
  //usage of useTranslation i18n
  const { t, ready } = useTranslation();

  let completeAttachment = false;
  // let canAddAttachmentFirst = false;
  // let canAddAttachmentSecond = false; 

  const removeFile = useCallback(async (fileId) => {
      try {
        await axios.delete(`${appConfig.apiDomaine}/files/${fileId}`);
        return true;
      } catch (error) {
        console.error("Error deleting file:", error);
        throw error;
      }
    }, []
  );

  const handleDeleteFile = useCallback(
    (fileId) => {
      DeleteConfirmation.fire(confirmDeleteConfig()).then(async (result) => {
        if (!result.value) return;

        try {
          await removeFile(fileId);

          ToastBottomEnd.fire(toastDeleteSuccessMessageConfig());
          window.location.reload();
        } catch (error) {
          if (error.response?.data?.error) {
            ToastBottomEnd.fire(
              toastErrorMessageWithParameterConfig(
                error.response.data.error
              )
            );
          } else {
            ToastBottomEnd.fire(toastDeleteErrorMessageConfig());
          }
        }
      });
    },
    [removeFile]
  );


  const checkRole = (array, role) => {
    let roleIsValid = false;
    array.map((elem, index) => {
      if (elem.name === role) roleIsValid = true;
    });
    return roleIsValid;
  };

  if (claim) {
    completeAttachment =
      verifyPermission(userPermissions, "attach-files-to-claim") &&
      claim.status !== "archived";

    // canAddAttachmentFirst =
    //   claim.status === "assigned_to_staff" &&
    //   checkRole(user.data.roles, "staff");
    // canAddAttachmentSecond =
    //   claim.status === "validated" &&
    //   checkRole(user.data.roles, "pilot") &&
    //   user.staff.is_active_pilot &&
    //   checkRole(user.data.roles, "staff") &&
    //   claim.active_treatment.responsible_staff_id === user.staff.id;
  }
  return ready ? (
    <div className="kt-wizard-v2__content" data-ktwizard-type="step-content">
      <div className="kt-heading kt-heading--md">
        {t("Liste de pièces jointes")}
      </div>
      <div className="kt-form__section kt-form__section--first">
        <div className="kt-wizard-v2__review">
          {!claim ? null : claim?.files?.length ? (
            claim.files.map((file, index) => (
              <div className="kt-wizard-v2__review-item" key={index}>
                <div className="kt-wizard-v2__review-content">
                  <a
                    href={`${appConfig.apiDomaine}${file?.url}`}
                    download={true}
                    target={"_blank"}
                  >
                    {file.title}
                  </a>
                  {claim.status == "assigned_to_staff" && file.attach_at == "attach_at_treatment" && (
                    <button
                      type="button"
                      className="btn btn-sm btn-clean btn-icon"
                      title="Supprimer"
                      onClick={() => handleDeleteFile(file.id)}
                    >
                      <i className="fa fa-trash text-danger"></i>
                    </button>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="kt-wizard-v2__review-item">
              <div className="kt-wizard-v2__review-title">
                {t("Pas de pièce jointe")}
              </div>
            </div>
          )}

          {claim && completeAttachment && claim.canAddAttachment && (
            <CompleteAttachment claimId={claim.id} />
          )}
        </div>
      </div>
    </div>
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
    user: state.user.user,
  };
};

export default connect(mapStateToProps)(AttachmentsButtonDetail);
